import React from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { getAccessibleMasters } from "../../const/const";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Reduxstore";

interface MastersMainProps {
  masterType: string;
  setPathname: (path: string) => void;
}

const MastersMain: React.FC<MastersMainProps> = ({
  masterType,
  setPathname,
}) => {
  // Filter masters based on user roles

  const rolls = useSelector((state:RootState)=>state.auth.role);
  const masters = getAccessibleMasters(rolls);

  return (
    <Grid container spacing={2} padding={2}>
      {masters.length > 0 ? (
        masters.map((master, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
              sx={{
                textAlign: "center",
                p: 2,
                boxShadow: 3,
                borderRadius: 2,
                cursor: "pointer",
              }}
             onClick={() =>
                master && setPathname(`/masters/${master.name.toLowerCase()}`)
              }

            >
              <CardContent>
                <Typography variant="h6" fontWeight="bold">
                  {master?.name}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))
      ) : (
        <Grid item xs={12}>
          <Typography variant="h6" textAlign="center">
            No Access to Masters
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default MastersMain;
